var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudLightning = function SvgCloudLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.439 11.223a.6.6 0 0 1 1.028.617l-2.277 3.796h2.704a.601.601 0 0 1 .514.91l-2.823 4.703a.6.6 0 1 1-1.028-.617l2.277-3.796H10.13a.602.602 0 0 1-.515-.909zM7.684 2.625a7.19 7.19 0 0 1 8.252 4.543h1.252a4.835 4.835 0 0 1 3.696 7.958 4.84 4.84 0 0 1-3.16 1.68.6.6 0 0 1-.132-1.192 3.636 3.636 0 0 0 3.231-3.814 3.636 3.636 0 0 0-3.634-3.433h-1.686a.6.6 0 0 1-.575-.427 5.987 5.987 0 1 0-8.304 7.12.601.601 0 0 1-.515 1.084A7.187 7.187 0 0 1 7.684 2.625"
  })));
};
export default SvgCloudLightning;